import { render } from "./DashBoard.vue?vue&type=template&id=232d8ced&scoped=true&ts=true"
import script from "./DashBoard.vue?vue&type=script&lang=ts"
export * from "./DashBoard.vue?vue&type=script&lang=ts"

import "./DashBoard.vue?vue&type=style&index=0&id=232d8ced&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232d8ced"]])

export default __exports__